import React, { useState, useEffect, useRef, useMemo } from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { styles } from './style';
import FlashFloodMap from './flashflood/FlashFloodMap';
import FlashFloodSidebar from './flashflood/flashfloodSidebar/FlashFloodSidebar';
import FlashFloodList from './flashflood/FlashFloodList';
import orderBy from 'lodash/orderBy';
import Papa from 'papaparse';
import dayjs from 'dayjs';
import 'dayjs/locale/th';

const useStyles = makeStyles(styles);
const initPath = process.env.REACT_APP_PATH;

export default function FlashFlood() {
  const { t } = useTranslation();
  const classes = useStyles();
  const markers = useRef([]);
  const [map, setMap] = useState(null);
  const [latestRainToday, setLatestRainToday] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [datas, setDatas] = useState([]);
  const [datasRiskArea, setDatasRiskArea] = useState([]);
  const [datasNhc, setDatasNhc] = useState([]);
  const [datasRiskAreaNhc, setDatasRiskAreaNhc] = useState([]);
  const [dataStorm, setDataStorm] = useState([]);
  const [arrayTambonId, setArrayTambonId] = useState([]);
  const [arrayTambonIdNhc, setArrayTambonIdNhc] = useState([]);
  const [datasRainToday, setDatasRainToday] = useState([]);
  const [header, setHeader] = useState(['', '']);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState({ header: '', content: null });
  const [showFcstRain, setShowFcstRain] = useState(true);
  const [mainRiver, setMainRiver] = useState(false);
  const [secoundRiver, setSecoundRiver] = useState(false);
  const [provinceBoundary, setProvinceBoundary] = useState(false);
  const [amphoeBoundary, setAmphoeBoundary] = useState(false);
  const [tambonBoundary, setTambonBoundary] = useState(false);
  const [rainfallEnabled, setRainfallEnabled] = useState(false);
  const [forecastDay, setForecastDay] = useState(1);
  const [forecastRainEnabled, setForecastRainEnabled] = useState(false);
  const [forecastRainDay, setForecastRainDay] = useState(1);
  const [dataRainfall24, setDataRainfall24] = useState([]);
  const [datasRainTodayMarker, setDatasRainTodayMarker] = useState([]);
  const [datasRainYesterday, setDatasRainYesterday] = useState([]);
  const [datasRain3day, setDatasRain3day] = useState([]);
  const [datasRain7day, setDatasRain7day] = useState([]);
  const [datasRain15Day, setDatasRain15Day] = useState([]);
  const [stormEnabled, setStormEnabled] = useState(false);
  const [riskAreaEnabled, setRiskAreaEnabled] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [riverEnabled, setRiverEnabled] = useState(false);
  const [geojsonTambon, setGeojsonTambon] = useState(null);
  const [ffpiEnabled, setFfpiEnabled] = useState(false);
  const [datasRain30Day, setDatasRain30Day] = useState([]);
  const [forecastAccumDay, setForecastAccumDay] = useState('');
  const [selectedRiskDays, setSelectedRiskDays] = useState(() => {
    const today = new Date().toISOString().split('T')[0];
    return [`day_${today}`];
  });
  const [datasRiskByDay, setDatasRiskByDay] = useState({});
  const flashFloodListRef = useRef(null);
  
  const HIMS_URL = process.env.REACT_APP_MIX_HYDRO_URL;

  const forecastDayToType = {
    1: 'rainfallYesterday',
    2: 'rainfallToday',
    3: 'rainfall24h',
    4: 'rainfall3day',
    5: 'rainfall7day',
    6: 'rainfall15day',
    7: 'rainfall30day',
  };

  const handleDownloadAll = () => {
    const data = mergedRiskArea.datasNhc.filter(d => d.provices !== undefined);
    const today = dayjs().format('YYYYMMDD');
    const rows = orderBy(data, 'rainForecast', 'desc').map((d) => ({
      ระดับ: 'วิกฤต',
      จังหวัด: d.provices?.replace('จ.', '') || '',
      อำเภอ: d.amphon?.replace('อ.', '') || '',
      ตำบล: d.tumbon?.replace('ต.', '') || '',
      FFPI: d.ffpi || '',
      'ฝนล่วงหน้า 1 วัน': d.rainForecast || '',
      'ฝนสะสมคาดการณ์ 5 วัน': d.rfhistoric || '',
      สถานีติดตาม: d.telestation || '',
      ลุ่มน้ำ: d.basin || '',
    }));

    if (rows.length === 0) return;

    const headers = Object.keys(rows[0]);
    const csvContent = [
      headers.join(','),
      ...rows.map((r) =>
        headers.map((h) => `"${(r[h] ?? '').toString().replace(/"/g, '""')}"`).join(',')
      ),
    ].join('\n');

    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `flash_flood_data_${today}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  dayjs.locale('th');

  useEffect(() => {
    if (map) {
      const timer = setTimeout(() => {
        map.invalidateSize();
      }, 150);
      return () => clearTimeout(timer);
    }
  }, [sidebarOpen, map]);

  const numberOfDays = 6;

  const thaiFormattedDate = (date) => {
    const d = dayjs(date).locale('th');
    return d.format('D MMM') + ` ${d.year() + 543}`;
  };

  const getFcstRainUrl = (day) => {
    const date = dayjs().subtract(1 - day, 'day').format('YYYYMMDD');
    return `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/fcst/${date}_day${day}.tif`;
  };

  const getAccumUrl = (days) => {
    const dateStr = dayjs().subtract(1, 'day').format('YYYYMMDD');
    return `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/wrfroms/${days}/wrfroms_${dateStr}1200.tif`;
  };

  const forecastOptions = useMemo(() => [
    ...Array.from({ length: 6 }, (_, index) => ({
      value: index + 1,
      label: dayjs().add(index, 'day').format('YYYY-MM-DD (07:00)'),
    })),
    { value: '3d', label: 'ฝนคาดการณ์สะสม 3 วัน' },
    { value: '5d', label: 'ฝนคาดการณ์สะสม 5 วัน' },
    { value: '7d', label: 'ฝนคาดการณ์สะสม 7 วัน' },
  ], []);

  useEffect(() => {
    const API = process.env.REACT_APP_API_URL;
    const HIMS_URL = process.env.REACT_APP_MIX_HYDRO_URL;
    const FEWS_URL = process.env.REACT_APP_FEWS_URL;

    fetch(`${HIMS_URL}tiffile/csv/header.txt`)
      .then(resp => resp.text())
      .then(results => {
        setHeader(Papa.parse(results).data.slice(1));
      });

    // NHC (flashflood_report.csv)
    fetch(`${HIMS_URL}tiffile/csv/flashflood_report.csv`)
      .then(resp => resp.arrayBuffer())
      .then(buffer => {
        const decoder = new TextDecoder('windows-874');
        const list = Papa.parse(decoder.decode(buffer)).data.slice(1);
        setDatasNhc(list.map(a => ({ provices: a[1], amphon: a[2], tumbon: a[3], ffpi: a[4], rainForecast: a[5], telestation: a[6], basin: a[7], rfhistoric: a[8] })));
        setDatasRiskAreaNhc(list.map(a => ({ tambon_id: a[0], ffpi: a[4], accrf: a[5], rfhistoric: a[8] })));
        setArrayTambonIdNhc(list.map(a => a[0]));
      });

    // FEWS (flashflood_report.txt)
    fetch(`${FEWS_URL}/model-output/data_portal/flashflood/flashflood_report.txt`)
      .then(resp => resp.text())
      .then(results => {
        const list = Papa.parse(results).data.slice(1);
        setDatas(list.map(a => ({ provices: a[1], amphon: a[2], tumbon: a[3], ffpi: a[4], rainForecast: a[5], telestation: a[6], basin: a[7] })));
        setDatasRiskArea(list.map(a => ({ tambon_id: a[0], ffpi: a[4], accrf: a[5] })));
        setArrayTambonId(list.map(a => a[0]));
      });

    // storm
    fetch(`${FEWS_URL}/model-output/data_portal/flashflood/storm.txt`)
      .then(resp => resp.text())
      .then(results => {
        const list = Papa.parse(results).data.slice(1);
        setDataStorm(list.map(a => ({ name: a[0], file: a[1], lat: a[2], long: a[3] })));
      });

    fetch('tiservice/v1/ws/flashflood/risk_area')
      .then(res => res.json())
      .then(result => {
        // console.log('API result:', JSON.stringify(result));
        // console.log('API result:', result);
        if (result.result === 'OK') {
          setDatas(result.data?.datas || []);
          setDatasRiskArea(result.data?.datasRiskArea || []);
          setDatasNhc(result.data?.datasNhc || []);
          setDatasRiskAreaNhc(result.data?.datasRiskAreaNhc || []);
          setArrayTambonId(result.data?.arrayTambonId || []);
          setArrayTambonIdNhc(result.data?.arrayTambonIdNhc || []);
          setHeader(result.data?.header || ['', '']);
        }
      })
      .catch(err => console.error('fetch flashflood error:', err));

    fetch('tiservice/v1/ws/flashflood/rain_today')
      .then(res => res.json())
      .then(result => {
        if (result.result === 'OK') {
          setDatasRainToday(result.data || []);
        }
      })
      .catch(err => console.error('fetch rain today error:', err));
  
    fetch(`${API}/public/rain_24h`)
      .then(res => res.json())
      .then(result => {
        const sorted = orderBy(result.data, ['rain_24h'], ['desc']);
        setDataRainfall24(sorted.filter(d => d.rain_24h > 0));
      });

    fetch(`${API}/public/rain_today`)
      .then(res => res.json())
      .then(result => {
        setDatasRainTodayMarker(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0));
      });

    fetch(`${API}/public/rain_yesterday`)
      .then(res => res.json())
      .then(result => {
        setDatasRainYesterday(orderBy(result.data, ['rainfall_value'], ['desc']).filter(d => d.rainfall_value > 0));
      });

    fetch(`${API}/provinces/rain3d`)
      .then(res => res.json())
      .then(result => {
        setDatasRain3day(orderBy(result.data, ['rain_3d'], ['desc']).filter(d => d.rain_3d > 0));
      });

    fetch(`${API}/provinces/rain7d`)
      .then(res => res.json())
      .then(result => {
        setDatasRain7day(result.data.filter(d => d.rain_7d > 0));
      });

    fetch(`${API}/provinces/rain15d`)
      .then(res => res.json())
      .then(result => {
        setDatasRain15Day(orderBy(result.data, ['rain_15d'], ['desc']).filter(d => d.rain_15d >= 0.1));
      });

    fetch('json/boundary/tambon.json')
      .then(res => res.json())
      .then(data => setGeojsonTambon(data))
      .catch(err => console.error('fetch tambon error:', err));

    fetch(`${API}/public/rain_monthly`)
      .then(res => res.json())
      .then(result => {
        if (!result.data) return;
        const sorted = orderBy(result.data, ['rainfall_value'], ['desc']);
        setDatasRain30Day(sorted.filter(d => d.rainfall_value >= 0.1));
      })
      .catch(err => console.error('rain_monthly error:', err));
  }, []);
  
  const getFileDay = (value) => {
    if (value === 'range_3') return 3;
    if (value === 'range_6') return 6;
    const today = dayjs().format('YYYY-MM-DD');
    const selected = value.replace('day_', '');
    const diff = dayjs(selected).diff(dayjs(today), 'day') + 1;
    return Math.min(Math.max(diff, 1), 6);
  };

  const fetchRiskByDay = async (values) => {
    const results = {};
    await Promise.all(
      values.map(async (val) => {
        let url;
        if (val === 'range_1') {
          url = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/txt/flashflood_report1.txt`;
        } else if (val === 'range_3') {
          url = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/txt/flashflood_report3.txt`;
        } else if (val === 'range_6') {
          url = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/txt/flashflood_report6.txt`;
        } else {
          const fileDay = getFileDay(val);
          url = `${process.env.REACT_APP_MIX_HYDRO_URL}tiffile/txt/flashflood_report_day${fileDay}.txt`;
        }

        try {
          const res = await fetch(url);
          const text = await res.text();
          const list = Papa.parse(text).data.slice(1);
          results[val] = {
            datasNhc: list.map(a => ({ provices: a[1], amphon: a[2], tumbon: a[3], ffpi: a[4], rainForecast: a[5], telestation: a[6], basin: a[7], rfhistoric: a[8] })),
            datasRiskArea: list.map(a => ({ tambon_id: a[0], ffpi: a[4], accrf: a[5], rfhistoric: a[8] })),
            arrayTambonId: list.map(a => a[0]),
          };
        } catch (err) {
          console.error(`fetch ${url} error:`, err);
        }
      })
    );
    setDatasRiskByDay(results);
  };

  useEffect(() => {
    if (selectedRiskDays.length > 0 && geojsonTambon) {
      fetchRiskByDay(selectedRiskDays);
    } else if (selectedRiskDays.length === 0) {
      setDatasRiskByDay({});
    }
  }, [selectedRiskDays, geojsonTambon]);
  

  const mergedRiskArea = useMemo(() => {
    if (Object.keys(datasRiskByDay).length === 0) {
      return {
        datasRiskArea: datasRiskAreaNhc,
        arrayTambonId: arrayTambonIdNhc,
        datasNhc: datasNhc,
      };
    }
    return {
      datasRiskArea: Object.values(datasRiskByDay).flatMap(d => d.datasRiskArea || []),
      arrayTambonId: [...new Set(Object.values(datasRiskByDay).flatMap(d => d.arrayTambonId || []))],
      datasNhc: Object.values(datasRiskByDay).flatMap(d => d.datasNhc || []),
    };
  }, [datasRiskByDay, datasRiskAreaNhc, arrayTambonIdNhc, datasNhc]);

  const handleModalOpen = (params) => {
    setModalContent(params);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const handleSetMap = (mapInstance) => {
    setMap(mapInstance);
  };

  return (
    <Box>
      {/* Title */}
      <Box display="flex" alignItems="center" mb={2}>
        <Box
          display="flex"
          className={classes.shapeCircle}
          alignItems="center"
          justifyContent="center"
        >
          <WarningIcon style={{ color: '#fff' }} />
        </Box>
        <Box p={1}>
          <Typography variant="h6" className={classes.titlePage}>
            {t('ระบบเตือนภัยน้ำท่วมฉับพลัน')}
          </Typography>
        </Box>
      </Box>

      {/* Map */}
      <Box
        mt={2}
        mb={2}
        style={{ width: '100%', height: 'calc(100vh - 150px)', display: 'flex', overflow: 'hidden' }}
      >
        <FlashFloodSidebar
          header={header}
          datasNhc={datasNhc}
          onOpenReport={(datas, hdr) => handleModalOpen({
            header: <p align="center">{`Flash Flood Risk Areas ${hdr[0]}`}</p>,
            content: <FlashFloodList datas={datas} header={hdr} />,
          })}
          onFcstRainToggle={(checked) => setShowFcstRain(checked)}
          onMainRiverToggle={(checked) => setMainRiver(checked)}
          onSecoundRiverToggle={(checked) => setSecoundRiver(checked)}
          onProvinceBoundaryToggle={(checked) => setProvinceBoundary(checked)}
          onAmphoeBoundaryToggle={(checked) => setAmphoeBoundary(checked)}
          onTambonBoundaryToggle={(checked) => setTambonBoundary(checked)}
          rainfallEnabled={rainfallEnabled}
          setRainfallEnabled={setRainfallEnabled}
          forecastDay={forecastDay}
          setForecastDay={setForecastDay}
          forecastRainEnabled={forecastRainEnabled}
          setForecastRainEnabled={setForecastRainEnabled}
          forecastRainDay={forecastRainDay}
          setForecastRainDay={setForecastRainDay}
          forecastOptions={forecastOptions}
          onStormToggle={(checked) => setStormEnabled(checked)}
          onRiskAreaToggle={(checked) => setRiskAreaEnabled(checked)}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          onRiverToggle={(val) => setRiverEnabled(val)}
          geojsonTambon={geojsonTambon}
          onStationSelect={(lat, lng) => {
            if (map) map.setView([lat, lng], 12);
          }}
          ffpiEnabled={ffpiEnabled}
          onFfpiToggle={(checked) => setFfpiEnabled(checked)}
          onRiskDaysChange={(vals) => setSelectedRiskDays(vals)}
          onForecastAccumChange={(val) => setForecastAccumDay(val)}
          onDownload={handleDownloadAll}
        />

        <div style={{ flex: 1, position: 'relative', height: '100%' , zIndex: 0 }}>
          <FlashFloodMap
            datas={datas}
            datasRiskArea={datasRiskArea}
            datasNhc={mergedRiskArea.datasNhc}
            datasRiskAreaNhc={mergedRiskArea.datasRiskArea}
            dataStorm={dataStorm}
            arrayTambonId={arrayTambonId}
            arrayTambonIdNhc={mergedRiskArea.arrayTambonId}
            markers={markers.current}
            location={[13.736717, 100.523186]}
            zoom={6}
            handleSetMap={handleSetMap}
            handleModalOpen={handleModalOpen}
            header={header}
            datasRainToday={datasRainToday}
            showMainRiver={mainRiver}
            showSecoundRiver={secoundRiver}
            showProvinceBoundary={provinceBoundary}
            showAmphoeBoundary={amphoeBoundary}
            showTambonBoundary={tambonBoundary}
            rainfallEnabled={rainfallEnabled}
            rainfallType={forecastDayToType[forecastDay]}
            dataRainfall24={dataRainfall24}
            datasRainTodayMarker={datasRainTodayMarker}
            datasRainYesterday={datasRainYesterday}
            datasRain3day={datasRain3day}
            datasRain7day={datasRain7day}
            datasRain15Day={datasRain15Day}
            stormEnabled={stormEnabled}
            riskAreaEnabled={riskAreaEnabled}
            sidebarOpen={sidebarOpen}
            onOpenSidebar={() => setSidebarOpen(true)}
            riverEnabled={riverEnabled}
            forecastRainEnabled={forecastRainEnabled && typeof forecastRainDay === 'number'}
            forecastRainDay={forecastRainDay}
            ffpiEnabled={ffpiEnabled}
            forecastRainUrl={forecastRainEnabled && typeof forecastRainDay === 'number' ? getFcstRainUrl(forecastRainDay) : null}
            datasRain30Day={datasRain30Day}
            forecastAccumUrl={forecastRainEnabled && typeof forecastRainDay === 'string' ? getAccumUrl(forecastRainDay) : null}
          />
        </div>
      </Box>

      {/* Modal */}
      <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="lg" fullWidth container={() => document.fullscreenElement || document.body} style={{ zIndex: 999999 }}>
        <DialogTitle>
          {modalContent.header}
          <IconButton
            onClick={handleModalClose}
            style={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ zIndex: 999999 }}>
          {modalContent.content}
        </DialogContent>
      </Dialog>
    </Box>
  );
}